import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/functional.module.scss';

/**
 * Renders list of checkboxes and handles logic related to them.
 *
 *  @param {object} checkboxData An object that contain all information on checkbox to print
 *  @param {func} onSelectCheckbox on change function to be fired
 *
 * @returns {JSX.Element}
 * @constructor
 */

function SearchCheckbox({ checkboxData, onSelectCheckbox }) {
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        setIsChecked(checkboxData.selected);
    }, [checkboxData]);

    // Checkbox change handler
    const onCheckboxChange = (event) => {
        setIsChecked(!isChecked);
        onSelectCheckbox(event);
    };

    // Return nothing if checkboxData is empty
    if (!checkboxData || (Object.keys(checkboxData).length === 0 && checkboxData.constructor === Object)) {
        return '';
    }

    return (
        <>
            <input
                id={checkboxData.data.replace(/\s|,/g, '-').toLowerCase()}
                type="checkbox"
                className={`funnelback-instant-search-facets__checkbox ${styles.facetCheckbox}`}
                tabIndex={0}
                data-name={checkboxData.label}
                data-url={checkboxData.toggleUrl}
                checked={isChecked}
                onChange={onCheckboxChange}
            />
            <label
                htmlFor={checkboxData.data.replace(/\s|,/g, '-').toLowerCase()}
                className={`funnelback-instant-search-facets__label ${styles.facetLabel}`}
            >
                {checkboxData.label}{' '}
                <span className={`funnelback-instant-search-facets__count ${styles.facetCount}`}>{checkboxData.count}</span>
            </label>
        </>
    );
}

SearchCheckbox.propTypes = {
    checkboxData: PropTypes.shape({
        data: PropTypes.string,
        label: PropTypes.string,
        count: PropTypes.number,
        selected: PropTypes.bool,
        toggleUrl: PropTypes.string,
    }),
    onSelectCheckbox: PropTypes.func,
};

SearchCheckbox.defaultProps = {
    checkboxData: {},
    onSelectCheckbox: () => {},
};

export default SearchCheckbox;
